import React, { useContext } from "react";
import { Header } from "../../Components";
import { Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../../Contexts/userContext";
import * as routes from "../../routes";

const Layout = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();

  if (location.pathname.startsWith(routes.ORDER) && !user) {
    // TODO: Redirect to login if not logged in
    return;
  }

  return (
    <React.Fragment>
      <div className="bg-white">
        <Header />
        <main className="container min-h-[80%] mt-14 p-4 sm:py-4 sm:px-0 mx-auto">
          <Outlet />
        </main>
      </div>
    </React.Fragment>
  );
};

export default Layout;
